<template>
  <v-row>
    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-text-field
        :label="$t('users.search.form.text')"
        hide-details="auto"
        filled
        type="text"
        v-model="form.searchText"
        clearable
      ></v-text-field>
    </v-col>

    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-autocomplete
        filled
        hide-details="auto"
        :items="userTypes"
        item-text="displayText"
        item-value="value"
        clearable
        :label="$t('users.search.form.user-type')"
        v-model="form.userTypeCode"
      ></v-autocomplete>
    </v-col>

    <v-col cols="12" md="4" class="mb-3">
      <v-autocomplete
        filled
        hide-details="auto"
        :items="statuses"
        item-text="displayText"
        item-value="value"
        clearable
        :label="$t('users.search.form.status')"
        v-model="form.isActive"
      ></v-autocomplete>
    </v-col>
  </v-row>
</template>
<script>
import { getUserSearchParams } from "@/services/user";

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      form: null,
      userTypes: [],
      statuses: [],
    };
  },
  watch: {
    form: {
      handler(val) {
        this.$emit("input", val);
      },
      deep: true,
    },
    value: {
      handler(val) {
        this.form = val;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {},
  async created() {
    const { statuses, userTypes } = await getUserSearchParams();
    this.statuses = statuses;
    this.userTypes = userTypes;
  },
};
</script>
